import { memo, useCallback } from "react";

import type { DiscountType } from "@/lib/gql/__generated__/graphql";

import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import { FormFieldLayout } from "../../../layouts";
import * as Constants from "../constants";
import { SettingHelpText } from "../setting-help-text";

export type Props = {
	children: React.ReactNode;

	// ディスカウント方法
	discountType: DiscountType;
	// ディスカウント方法の変更
	onChangeDiscountType: (value: DiscountType) => void;
};

export const OrdinaryFormFieldComposition = memo(({ children, discountType, onChangeDiscountType }: Props) => {
	/**
	 * ディスカウント方法の変更
	 */
	const handleChangeDiscountType = useCallback(
		(value: string) => {
			onChangeDiscountType(value as DiscountType);
		},
		[onChangeDiscountType],
	);

	return (
		<FormFieldLayout title="ディスカウントの金額">
			<div className="space-y-4">
				<RadioGroupField
					value={discountType}
					options={Constants.DiscountTypeOptions}
					handleValueChange={handleChangeDiscountType}
				/>

				<div className="space-y-2">
					{children}

					<p className="whitespace-pre-wrap text-sm text-caption-50">
						<SettingHelpText />
					</p>
				</div>
			</div>
		</FormFieldLayout>
	);
});
